// @ts-expect-error
import ColorThief from '../../node_modules/colorthief/dist/color-thief.mjs';

/* eslint-disable eqeqeq */
function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.addEventListener('load', () => {
      resolve(img);
    });
    img.addEventListener('error', reject);
    img.src = src;
  });
}

function getAverageRGB(imgEl: HTMLImageElement) {
  var blockSize = 5, // only visit every 5 pixels
    defaultRGB = { r: 0, g: 0, b: 0 }, // for non-supporting envs
    canvas = document.createElement('canvas'),
    context = canvas.getContext && canvas.getContext('2d'),
    data,
    width,
    height,
    i = -4,
    length,
    rgb = { r: 0, g: 0, b: 0 },
    count = 0;

  if (!context) {
    return defaultRGB;
  }

  height = canvas.height = imgEl.naturalHeight || imgEl.offsetHeight || imgEl.height;
  width = canvas.width = imgEl.naturalWidth || imgEl.offsetWidth || imgEl.width;

  context.drawImage(imgEl, 0, 0);

  try {
    data = context.getImageData(0, 0, width, height);
  } catch (e) {
    /* security error, img on diff domain */
    return defaultRGB;
  }

  length = data.data.length;

  while ((i += blockSize * 4) < length) {
    ++count;
    rgb.r += data.data[i];
    rgb.g += data.data[i + 1];
    rgb.b += data.data[i + 2];
  }

  // ~~ used to floor values
  rgb.r = ~~(rgb.r / count);
  rgb.g = ~~(rgb.g / count);
  rgb.b = ~~(rgb.b / count);
  return rgb;
}

function componentToHex(c: any) {
  var hex = c.toString(16);
  return hex.length == 1 ? '0' + hex : hex;
}

function rgbToHex(r: number, g: number, b: number) {
  return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

export const getImageAnalysis = async (src: string) => {
  try {
    const img = await loadImage(src);
    const response = getAverageRGB(img);
    return rgbToHex(response.r, response.g, response.b);
  } catch (error) {
    return '#535353';
  }
};

const dominantColorCache: Record<string, string> = {};
const leastDominantColorCache: Record<string, string> = {};

export const getImageAnalysis2 = async (src: string) => {
  if (dominantColorCache[src]) return dominantColorCache[src];
  try {
    // Attempt with fast image CDN proxy to guarantee CORS headers
    const proxiedSrc = `https://wsrv.nl/?url=${encodeURIComponent(src)}`;
    const img = await loadImage(proxiedSrc);
    var colorThief = new ColorThief();
    // @ts-ignore
    const color = rgbToHex(...colorThief.getColor(img));
    dominantColorCache[src] = color;
    return color;
  } catch (error) {
    try {
      // Fallback to original src if proxy fails
      const img = await loadImage(src);
      var colorThief2 = new ColorThief();
      // @ts-ignore
      const color = rgbToHex(...colorThief2.getColor(img));
      dominantColorCache[src] = color;
      return color;
    } catch (e) {
      return '#121212';
    }
  }
};

export const getLeastDominantColor = async (src: string) => {
  if (leastDominantColorCache[src]) return leastDominantColorCache[src];
  const fallbackColor = '#ffffff';
  try {
    const proxiedSrc = `https://wsrv.nl/?url=${encodeURIComponent(src)}`;
    const img = await loadImage(proxiedSrc);
    var colorThief = new ColorThief();
    // @ts-ignore
    const palette = colorThief.getPalette(img, 5);
    if (!palette || palette.length === 0) return fallbackColor;
    const leastDominant = palette[palette.length - 1];
    const color = rgbToHex(leastDominant[0], leastDominant[1], leastDominant[2]);
    leastDominantColorCache[src] = color;
    return color;
  } catch (error) {
    try {
      const img = await loadImage(src);
      var colorThief2 = new ColorThief();
      // @ts-ignore
      const palette = colorThief2.getPalette(img, 5);
      if (!palette || palette.length === 0) return fallbackColor;
      const leastDominant = palette[palette.length - 1];
      const color = rgbToHex(leastDominant[0], leastDominant[1], leastDominant[2]);
      leastDominantColorCache[src] = color;
      return color;
    } catch (e) {
      return fallbackColor;
    }
  }
};
